export default __webpack_public_path__ + "static/media/cancelled.777c5744.svg";